module.exports = __webpack_public_path__ + "img/line.9876b2d7.svg";